import { Injectable } from '@angular/core';
import { PortalProductsSubscriptionsState, PortalProductsSubscriptionsStore } from './portal-products-subscriptions.store';
import { QueryEntity } from '@datorama/akita';

/**
 * This query will handle the queries made
 * to the subscribed portal products store.
 */

@Injectable({ providedIn: 'root' })
export class PortalProductsSubscriptionsQuery extends QueryEntity<PortalProductsSubscriptionsState> {
  constructor(protected store: PortalProductsSubscriptionsStore) {
    super(store);
  }

  /**
   * @param productTypes An array of portal product types to be returned
   * @returns Returns all subscribed portal products of the given
   * portal product types from the array passed.
   */
  selectSubscriptionsByProductTypes(productTypes: number[]) {
    return this.selectAll({
      filterBy: [(sub) => productTypes.includes(sub.ProductType)],
    });
  }
}
